import React, { useState } from "react";
import QRCode from "qrcode";

function QRCodePage({ match }) {
    const [code, setCode] = useState(null);

    const { id } = match.params;
    // Code
    /**
     * Generates a qr-code
     * @param {string} text text to generate code of
     */
    const opts = {
        margin: 1,
    };
    const getCode = async (text) => {
        if (text) {
            const data = btoa(JSON.stringify({ id: text, app: "igenie" }));
            const res = await QRCode.toDataURL(data, opts);
            setCode(res);
        }
    };

    const Download = () => {
        let link = document.createElement("a");
        link.setAttribute("href", code);
        link.setAttribute("download", "igenie-qrcode.png");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    getCode(id);
    return (
        <div className="card">
            <div className="card-head">
                <header>Patient QRCode</header>
            </div>
            <div className="card-body text-center" style={{ marginTop: "2em" }}>
                <img className="img-thumbnail" src={code} alt="preview" />
            </div>
            <div className="card-footer text-center">
                <button type="button" onClick={Download} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle margin-right-10 btn-success">
                    <i className="material-icons">cloud_download</i> Download
                </button>
            </div>
        </div>
    );
}

export default QRCodePage;
